// extracted by mini-css-extract-plugin
export default {"fadeIn":"Fade_fadeIn__MiBSh","fadeOut":"Fade_fadeOut__fJ-90"};